import styled from 'styled-components'
export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.body};
  padding: 32px 0px;
  font-family: ${({ theme }) => theme.fontFamily.visuelt};
  line-height: 24px;
  font-style: normal;
  .spinner_container {
    display: flex;
    justify-content: center;
    /* align-items: center; */
    height: 100vh;
  }
  .flexed {
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      cursor: pointer;
    }
  }

  .loading {
    width: 100%;
  }

  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    width: 100%;

    padding-top: 0px;
  }
  /* .title {
    color: ${({ theme }) => theme.colors.dark};
  } */
  h2 {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.navyBlue};
    font-size: ${({ theme }) => theme.fontSize.x5};
    margin-top: -20px;
  }
  .link {
    margin-top: 20px;
  }
  a {
    font-family: ${({ theme }) => theme.fontFamily.inter};
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x1};
  }
`
